module.exports = __webpack_public_path__ + "img/growatt.85fd8cd1.svg";